var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipPlagiarism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.74984 18H4.74984C3.64526 18 2.74984 17.1045 2.74984 16L2.74992 4.00001C2.74993 2.89545 3.64536 2.00002 4.74992 2.00002H13.7501C14.8547 2.00002 15.7501 2.89545 15.7501 4.00002V8.00002M16.2502 15.5L17.2502 16.5M16.7502 13.5C16.7502 14.8807 15.6309 16 14.2502 16C12.8694 16 11.7502 14.8807 11.7502 13.5C11.7502 12.1193 12.8694 11 14.2502 11C15.6309 11 16.7502 12.1193 16.7502 13.5Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipPlagiarism);
export default __webpack_public_path__ + "static/media/chip-plagiarism.1b36d1b2877e21dbb7db15704dd7e88b.svg";
export { ForwardRef as ReactComponent };